/* ==========================================================================
   KC recent bekeken + bestsellers

   Recent: dezelfde localStorage-sleutel als de oude recently-viewed.
   Bestsellers: aparte collectie, of deze collectie met sort_by=best-selling.
   ========================================================================== */

(function () {
  'use strict';

  if (customElements.get('kc-recently-viewed')) return;

  class KcRecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === '1') return;
      this.dataset.ready = '1';

      this.list = this.querySelector('[data-kc-rv-list]');
      this.best = this.querySelector('[data-kc-rv-best]');
      this.initTabs();
      this.loadRecent();
      this.loadBest();
    }

    initTabs() {
      var buttons = this.querySelectorAll('[data-kc-rv-tab]');
      var panels = this.querySelectorAll('[data-kc-rv-panel]');
      if (buttons.length < 2) return;

      function select(name) {
        Array.prototype.forEach.call(buttons, function (btn) {
          var on = btn.dataset.kcRvTab === name;
          btn.setAttribute('aria-selected', on ? 'true' : 'false');
          btn.tabIndex = on ? 0 : -1;
        });
        Array.prototype.forEach.call(panels, function (panel) {
          panel.hidden = panel.dataset.kcRvPanel !== name;
        });
      }

      Array.prototype.forEach.call(buttons, function (btn) {
        btn.addEventListener('click', function () {
          select(btn.dataset.kcRvTab);
        });
        btn.addEventListener('keydown', function (e) {
          var i = Array.prototype.indexOf.call(buttons, btn);
          var next = null;
          if (e.key === 'ArrowRight') next = buttons[(i + 1) % buttons.length];
          if (e.key === 'ArrowLeft') next = buttons[(i - 1 + buttons.length) % buttons.length];
          if (!next) return;
          e.preventDefault();
          select(next.dataset.kcRvTab);
          next.focus();
        });
      });
    }

    readIds() {
      var limit = parseInt(this.dataset.limit, 10) || 4;
      var skip = this.dataset.skipId || '';
      var raw = [];

      try {
        if (typeof webvista !== 'undefined' && webvista.retrieveData) {
          raw = webvista.retrieveData('recently-viewed') || [];
        } else {
          raw = JSON.parse(localStorage.getItem('recently-viewed') || '[]');
        }
      } catch (e) {
        raw = [];
      }

      if (!Array.isArray(raw)) return [];

      return raw
        .filter(function (id) { return String(id) !== String(skip); })
        .slice(-limit)
        .reverse();
    }

    loadRecent() {
      if (!this.list) return;
      var ids = this.readIds();
      if (!ids.length) return;

      var endpoint = this.dataset.searchUrl;
      var section = this.dataset.section;
      if (!endpoint || !section) return;

      var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
      var url = endpoint + '?q=' + encodeURIComponent(q) +
        '&type=product&section_id=' + encodeURIComponent(section) +
        '&ose=false';

      var self = this;
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          self.fill(self.list, html, '[data-kc-rv-results]', ids);
        })
        .catch(function () {});
    }

    loadBest() {
      var source = this.dataset.bestUrl;
      var section = this.dataset.section;
      if (!source || !section || !this.best) return;

      var join = source.indexOf('?') === -1 ? '?' : '&';
      var url = source + join + 'sort_by=best-selling&section_id=' + encodeURIComponent(section);

      var self = this;
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          self.fill(self.best, html, '[data-kc-rv-best-results]');
        })
        .catch(function () {});
    }

    fill(target, html, selector, ids) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.querySelector(selector);
      if (!source && selector === '[data-kc-rv-results]') {
        source = doc.querySelector('[data-kc-rv-list]');
      }
      if (!source && selector === '[data-kc-rv-best-results]') {
        source = doc.querySelector('[data-kc-rv-best]');
      }
      if (!source) return;

      var fragment = document.createDocumentFragment();
      var items = [];
      if (ids && ids.length) {
        ids.forEach(function (id) {
          var item = source.querySelector('[data-product-id="' + id + '"]');
          if (item) items.push(item);
        });
      } else {
        items = Array.prototype.slice.call(source.children);
      }
      items.forEach(function (item) {
        fragment.appendChild(item);
      });

      if (!fragment.childNodes.length) return;
      target.innerHTML = '';
      target.appendChild(fragment);
    }
  }

  customElements.define('kc-recently-viewed', KcRecentlyViewed);
})();
